import { render, staticRenderFns } from "./Day.vue?vue&type=template&id=52f9c0d6&"
import script from "./Day.vue?vue&type=script&lang=js&"
export * from "./Day.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports